export default "__VITE_ASSET__IOUppnQg__"